import React, { useEffect, useState } from "react";
import { createStackNavigator } from "@react-navigation/stack";
import { RewardsIntroSplashScreenStep1 } from "../../screens/new/rewards-intro-splash-screen-step-1";
import { RewardsIntroSplashScreenStep2 } from "../../screens/new/rewards-intro-splash-screen-step-2";
import { RewardsIntroSplashScreenStep3 } from "../../screens/new/rewards-intro-splash-screen-step-3";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../redux/reducers";
import { RewardsService } from "../../api/RewardsService";
import { fetchRewardsData } from "../../redux/actions/actionCreators/reward";
import { SafeAreaView, StatusBar } from "react-native";
import { useReservationInformation } from "../../hooks/useReservationInformation";
import { StackActions, useNavigation } from "@react-navigation/native";
import { FullScreenLoader } from "../../components/new/loader/full-screen-loader";
import { Footer } from "../../components/new/footer/footer";
import { theme } from "ui-components";
import { UserAppState } from "../../enums/user-app-state";
import { fetchUserAppStateSuccess } from "../../redux/actions/actionCreators/userAppState";
import { RewardsType } from "../../enums";
import { getRewardByRewardType } from "../../screens/new/utils/helper";
import { RewardsData } from "../../redux/reducers/reward";

const Stack = createStackNavigator();

const LoaderScreenToDetermineRewardsIntroOrHome = () => {
  const [loading, setLoading] = useState(true);
  const [rewardsFetchingStarted, setRewardsFetchingStarted] = useState(false);
  const timeoutDuration = 8000; // Replace with your desired timeout duration in milliseconds
  const navigation = useNavigation();
  const { reservations, hasError } = useReservationInformation();
  const dispatch = useDispatch();
  const cognitoUser = useSelector((state: RootState) => state.auth.cognitoUser);
  const logger = useSelector((state: RootState) => state.logger);
  const rewardsApiService = new RewardsService(cognitoUser, dispatch);

  const rewardsData = useSelector((state: RootState) => state.reward.data) as RewardsData;
  const loadingRewards = useSelector((state: RootState) => state.reward.loading);
  const errorFetchingRewards = useSelector((state: RootState) => state.reward.error);

  function navigateToHome() {
    setLoading(false);
    navigation.dispatch(StackActions.replace("Reservation"));
  }

  function navigateToRewardsIntroSplashScreenStep1() {
    setLoading(false);
    navigation.dispatch(StackActions.replace("RewardsIntroSplashScreenStep1"));
  }
  // Function to fetch rewards with a configurable timeout
  async function determineIfFirstLoginToShowRewardSplash() {
    let reservationsDCashPaymentsCleared = true;
    reservations?.forEach((reservation: any) => {
      if (reservation?.recovery_payments?.length > 0) {
        reservationsDCashPaymentsCleared = false;
      }
    });
    if (!reservationsDCashPaymentsCleared) {
      navigateToHome();
    } else if (rewardsData?.ledger_items) {
      const firstLoginReward = getRewardByRewardType(rewardsData, RewardsType?.FIRST_LOGIN);
      if (firstLoginReward && firstLoginReward?.redeemed_at == null) {
        navigateToRewardsIntroSplashScreenStep1();
      } else {
        navigateToHome();
      }
    } else {
      navigateToHome();
    }
  }

  async function getStateAndNavigate() {
    if (!loadingRewards && !errorFetchingRewards) {
      if (
        rewardsData &&
        Object.keys(rewardsData).length > 0 &&
        rewardsData?.userAppState &&
        rewardsData?.userAppState == UserAppState?.UNIFIED
      ) {
        dispatch(fetchUserAppStateSuccess(UserAppState.UNIFIED));
        determineIfFirstLoginToShowRewardSplash();
      } else {
        dispatch(fetchUserAppStateSuccess(UserAppState.PAYMENT_ONLY));
        navigateToHome();
      }
    } else if (errorFetchingRewards) {
      // Navigate to home screen in case of error
      navigateToHome();
    }
  }

  useEffect(() => {
    if (reservations && reservations.length) {
      const data = {
        cognitoUser: cognitoUser,
        propertyId: reservations[0]?.property?.id,
        accountingId: reservations[0]?.accounting_id,
      };
      dispatch(fetchRewardsData(data));
      setRewardsFetchingStarted(true);
    } else if (hasError) {
      // Navigate to home screen in case of error
      navigateToHome();
    }
  }, [hasError, dispatch]);

  useEffect(() => {
    if (rewardsFetchingStarted) {
      getStateAndNavigate();
    }
  }, [rewardsFetchingStarted, loadingRewards, rewardsData, errorFetchingRewards]);

  return (
    <SafeAreaView style={{ flex: 1, backgroundColor: "#FFFFFF" }}>
      <StatusBar
        hidden={false}
        translucent={false}
        backgroundColor={theme.colors.white}
        barStyle={"dark-content"}
      />
      <FullScreenLoader loading={loading} />
      <Footer />
    </SafeAreaView>
  );
};

export const RewardIntroStack = () => {
  return (
    <Stack.Navigator
      screenOptions={{ headerMode: "screen", showFullMenu: true }}
      initialRouteName={"LoaderScreenToDetermineRewardsIntroOrHome"}>
      <Stack.Screen
        name="LoaderScreenToDetermineRewardsIntroOrHome"
        component={LoaderScreenToDetermineRewardsIntroOrHome}
        options={({}) => ({
          headerShown: false,
        })}
      />
      <Stack.Screen
        name="RewardsIntroSplashScreenStep1"
        component={RewardsIntroSplashScreenStep1}
        options={({}) => ({
          headerShown: false,
        })}
      />
      <Stack.Screen
        name="RewardsIntroSplashScreenStep2"
        component={RewardsIntroSplashScreenStep2}
        options={({}) => ({
          headerShown: false,
        })}
      />
      <Stack.Screen
        name="RewardsIntroSplashScreenStep3"
        component={RewardsIntroSplashScreenStep3}
        options={({}) => ({
          headerShown: false,
        })}
      />
    </Stack.Navigator>
  );
};
